import React from 'react';
import { StateResultsProvided } from 'react-instantsearch-core';
import { InlineLoader } from 'atoms/InlineLoader/InlineLoader';
import { connectStateResults } from 'react-instantsearch-dom';

const SearchingIndicatorConnected: React.FC<StateResultsProvided> = ({ searching }) => {
  if (!searching) return null;
  return <InlineLoader />;
};

export const SearchingIndicator = connectStateResults(SearchingIndicatorConnected);
